<script lang='ts'>
import { reactive, defineComponent, onMounted, ref, computed } from '@vue/composition-api';

interface IProps {
    collapsedHeight: number;
}

const AppExpandable = defineComponent({
    name: 'AppExpandable',
    props: {
        collapsedHeight: {
            type: Number,
            default: 50,
        },
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props: IProps, ctx) {
        const state = reactive({
            mounted: false,
            isExpanded: false,
        });

        const content = ref<HTMLElement>(null);

        const shouldShowViewMore = computed(() => {
            if (!state.mounted) {
                return false;
            }

            return content.value.clientHeight > props.collapsedHeight;
        });

        onMounted(() => {
            // the DOM element will be assigned to the ref after initial render
            state.mounted = true;
        });

        return {
            state,
            content,
            shouldShowViewMore,
        };
    },
});

export default AppExpandable;
</script>

<template>
  <div class="expandable-container" :class="{ expanded: state.isExpanded }" :style="{'height': shouldShowViewMore ? collapsedHeight + 'px' : 'auto'}">
    <div ref="content">
      <slot />
    </div>

    <div v-if="!state.isExpanded && shouldShowViewMore" class="view-more-wrapper">
      <v-btn
        color="secondaryButton"
        depressed
        class="show-more"
        @click.prevent="state.isExpanded = true"
      >
        show more
      </v-btn>
    </div>
  </div>
</template>

<style lang='scss' scoped>
.expandable-container {
    overflow: hidden;
    position: relative;

    &.expanded {
        height: auto !important;
    }
}

.view-more-wrapper {
    background: linear-gradient(rgba(244, 245, 247, 0), rgba(244, 245, 247, 0) 15px, rgba(252, 252, 252, 0.9) 45px);
    height: 75px;
    padding-top: 45px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
}

.show-more {
    bottom: 0;
}
</style>